<template>
  <div :id="mapId" :style="styles" />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  model: {
    prop: 'data',
    event: 'set-object'
  },

  props: {
    show: { type: Boolean, default: () => false },

    data: {
      type: Object,
      default: () => {}
    },

    mapId: {
      type: String,
      default: () => 'map'
    },

    dark: {
      type: Boolean,
      default: () => false
    },

    width: {
      type: String,
      default: () => '100%'
    },

    height: {
      type: String,
      default: () => '100%'
    },

    error: {
      type: String,
      default: () => ''
    }
  },

  data () {
    return {
      map: undefined,
      google: null,
      objectMarker: null
    }
  },

  computed: {
    ...mapGetters(['color']),

    object: {
      get () {
        return this.data
      },

      set (value) {
        this.$emit('set-object', value)
      }
    },

    styles () {
      return `
        width: ${this.width};
        height: ${this.height};
        z-index: 1;
      `
    },

    errorMessage () {
      if (this.error.length > 0) {
        return this.error
      }
      return null
    }
  },

  watch: {
    show (value) {
      if (value) {
        if (this.object.latitude && this.object.longitude) {
          const location = new this.google.maps.LatLng(this.object.latitude, this.object.longitude)
          this.placeMarker(location)
        }
      } else {
        this.removeMarker()
      }
    },

    object: {
      handler (value) {
        if (this.show) {
          if (value.latitude && value.longitude) {
            const location = new this.google.maps.LatLng(value.latitude, value.longitude)
            this.placeMarker(location)
          }
        }
      },
      deep: true
    }
  },

  beforeCreate () {
    /* eslint-disable no-undef, no-unused-vars */
    this.$googlemaps.load().then(() => {
      this.google = google
      this.initMap()
    })
    /* eslint-enable */
  },

  created () {},

  mounted () {},

  beforeDestroy () {},

  methods: {
    async initMap () {
      let initialLocation = { lat: 0, lng: 0 }
      this.map = new this.google.maps.Map(
        document.getElementById(this.mapId),
        {
          zoom: 15,
          // mapTypeControl: true,
          streetViewControl: false,
          center: initialLocation,
          scaleControl: true

        }
      )
      const self = this
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          initialLocation = new self.google.maps.LatLng(
            position.coords.latitude, position.coords.longitude)
          self.map.setCenter(initialLocation)
          console.log('initMap ~ initialLocation', initialLocation)
        })
      }

      setTimeout(() => {
        this.map.addListener('click', function (e) {
          self.placeMarker(e.latLng, self.map)
        })
      }, 0)
    },

    removeMarker () {
      if (this.objectMarker) {
        this.objectMarker.setMap(null)
        this.objectMarker = null
      }
    },

    setCupCoordinates (location) {
      this.object.latitude = location.lat()
      this.object.longitude = location.lng()
    },

    placeMarker (location) {
      this.removeMarker()

      this.objectMarker = new this.google.maps.Marker({
        position: location,
        map: this.map
      })

      this.setCupCoordinates(location)

      setTimeout(() => {
        this.map.setCenter(this.objectMarker.getPosition())
      }, 100)
    }
  }
}
</script>
